export default "__VITE_ASSET__$rIRCq7t__"